import React from "react";
import SlideCard from "./SlideCard";

const SliderProduct = () => {
  const imgProduct = [
    "./images/Slide/productshow_1.jpg",
    "./images/Slide/productshow_2.jpg",
  ];
  return (
    <section className="mb-3">
      <div>
        <SlideCard imgRender={imgProduct} />
      </div>
    </section>
  );
};

export default SliderProduct;
